import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/new.css'; // Custom styles

// Navbar Component
const FullNavbar = () => {
  const [expanded, setExpanded] = useState(false);

  // Handle closing the navbar after link click
  const handleLinkClick = () => {
    setExpanded(false); // Close the navbar toggle
  };

  return (
    <Navbar expand="lg" className="custom-navbar" sticky="top" expanded={expanded} onToggle={() => setExpanded(!expanded)}>
      <Container fluid>
        <Navbar.Brand as={Link} to="/" className="brand" onClick={handleLinkClick}>Majestic Lawn</Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="me-auto">
            {/* Use Link without smooth scroll for normal page navigation */}
            <Nav.Link as={Link} to="/" onClick={handleLinkClick}>
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/About" onClick={handleLinkClick}>
              About
            </Nav.Link>
            <Nav.Link as={Link} to="/Service" onClick={handleLinkClick}>
              Services
            </Nav.Link>
            <Nav.Link as={Link} to="/Contact" onClick={handleLinkClick}>
              Contact
            </Nav.Link>
            <Nav.Link as={Link} to="/Photos" onClick={handleLinkClick}>
              Gallery
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default FullNavbar;
